/**
 * AccountPage > Privacy tab — renders the full Privacy Policy inline.
 *
 * RC 1.35.F1 P0-2 — the old 20-line "This section will provide data
 * controls in a future update." stub is gone. We now mount the
 * canonical `PrivacyPolicyPage` in embedded mode so the same legal
 * copy is visible from the account shell as from the public `/privacy`
 * route. Zero behaviour delta on the rest of the account flow.
 */
import PrivacyPolicyPage from './legal/PrivacyPolicyPage';

export default function PrivacyPage() {
  return <PrivacyPolicyPage embedded />;
}
